import * as React from 'react';
import type {
  CTAWidgetPayload,
  ActionEvent,
} from 'src/components/agentic-ui/types';

import {BodyMedium, Button, Link} from '@spaced-out/ui-design-system';
import css from './cta-widget.css';


interface CTAWidgetProps {
  data: CTAWidgetPayload;
  publishMessageAction?: (action: ActionEvent) => void;
}

const CTAWidget = ({
  data,
  publishMessageAction,
}: CTAWidgetProps): React.ReactNode => {
  try {
    const {title = '', items = []}: CTAWidgetPayload = data;
    return (
      <div className={css.ctaWidgetContainer}>
        {title && (
          <BodyMedium className={css.ctaWidgetTitle}>{title}</BodyMedium>
        )}
        <div className={css.ctaWidgetButtonsContainer}>
          {items.map((item: any) => {
            const {id, event, type, buttonType, ...props} = item;
            switch (type) {
              case 'button':
                const {product, name, payload} = item.event;
                return (
                  <Button
                    key={item.id}
                    onClick={() => {
                      //Note: will decide on this later
                      // window.open(item.url, '_blank');
                      publishMessageAction?.({product, event: name, payload});
                    }}
                    type={buttonType || 'tertiary'}
                    size="small"
                    isFluid={false}
                    {...props}
                  >
                    {item.text}
                  </Button>
                );
              case 'link': {
                const {product, name, payload} = item.event;
                return (
                  <Link
                    key={item.id}
                    onClick={() => {
                      publishMessageAction?.({product, event: name, payload});
                    }}
                    underline={false}
                    {...props}
                  >
                    {item.text}
                  </Link>
                );
              }
              default:
                return null;
            }
          })}
        </div>
      </div>
    );
  } catch {
    return null;
  }
};

export default CTAWidget;
